module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ExamResultView.js"));
	}, "ExamResultView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ExamResultView!./src/pages/Learn/Exam/ExamResult/ExamResultView.js
// module id = 2219
// module chunks = 367